export type StripeCheckoutUiMode = "embedded" | "hosted";

/**
 * `NEXT_PUBLIC_STRIPE_CHECKOUT_UI`:
 * - `embedded` (default) — `/checkout` with Stripe Embedded Checkout
 * - `hosted` — redirect to Stripe-hosted Checkout (`checkout.stripe.com`)
 */
export function getStripeCheckoutUiMode(): StripeCheckoutUiMode {
	const raw = process.env.NEXT_PUBLIC_STRIPE_CHECKOUT_UI?.trim().toLowerCase();
	return raw === "hosted" ? "hosted" : "embedded";
}

export function isEmbeddedCheckoutEnabled(): boolean {
	return getStripeCheckoutUiMode() === "embedded";
}
